var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5505 5.78143C11.5505 6.02996 11.752 6.23143 12.0005 6.23143H13.1405C13.2195 6.23143 13.2884 6.23951 13.376 6.24976C13.3984 6.25239 13.422 6.25516 13.4474 6.25797L13.4515 6.25843C13.5477 6.26912 13.7282 6.2892 13.9038 6.23358C14.1327 6.16109 14.2828 5.99125 14.3618 5.77914C14.4301 5.59599 14.4505 5.37158 14.4505 5.12196V4.3823C14.4505 3.66381 14.2869 2.99101 14.0045 2.47935L14.0045 2.47935L14.0032 2.47705C13.7249 1.97976 13.2725 1.55975 12.6812 1.55006L12.6812 1.55H12.6738C12.2537 1.55 11.9646 1.84896 11.8064 2.12972C11.6399 2.42521 11.5505 2.80341 11.5505 3.19711V5.78143Z",
    stroke: "currentColor",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.45C12.7485 2.45 12.95 2.24853 12.95 2C12.95 1.75147 12.7485 1.55 12.5 1.55H5.28125H4.625C3.56413 1.55 2.77339 1.83234 2.25154 2.36921C1.73232 2.90337 1.55 3.61703 1.55 4.33208V4.9151V13.0774C1.55 13.5319 1.84327 13.8631 2.17989 14.0126C2.51531 14.1616 2.94295 14.1576 3.30006 13.9179C3.30046 13.9176 3.30085 13.9174 3.30124 13.9171L4.42137 13.1722L4.42171 13.172C4.51589 13.1093 4.65758 13.1198 4.73915 13.1919C4.73929 13.192 4.73943 13.1921 4.73957 13.1922L5.82792 14.165L5.82892 14.1659C6.25533 14.5447 6.93217 14.5447 7.35858 14.1659L7.0597 13.8295L7.35858 14.1659L8.46107 13.1864C8.53557 13.1202 8.67507 13.11 8.76141 13.1691L8.76139 13.1691L8.76613 13.1722L9.88833 13.9185L9.88975 13.9194C10.2542 14.1598 10.6696 14.1485 10.9875 13.9282C11.2843 13.7225 11.45 13.3688 11.45 13V3.08867C11.45 2.96713 11.5226 2.81741 11.7309 2.67695C11.9376 2.53754 12.2242 2.45 12.5 2.45Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36133 5.92383C4.24483 5.92383 4.15039 6.01827 4.15039 6.13477C4.15039 6.25126 4.24483 6.3457 4.36133 6.3457H7.90508C8.02158 6.3457 8.11602 6.25126 8.11602 6.13477C8.11602 6.01827 8.02158 5.92383 7.90508 5.92383H4.36133Z",
    stroke: "currentColor",
    strokeWidth: 0.421875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80469 8.28589C4.68819 8.28589 4.59375 8.38033 4.59375 8.49683C4.59375 8.61332 4.68819 8.70776 4.80469 8.70776H7.4625C7.579 8.70776 7.67344 8.61332 7.67344 8.49683C7.67344 8.38033 7.579 8.28589 7.4625 8.28589H4.80469Z",
    stroke: "currentColor",
    strokeWidth: 0.421875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBills);
export default __webpack_public_path__ + "static/media/bills.06d045d46e8b6ff348bd08ce7de96720.svg";
export { ForwardRef as ReactComponent };